<template>
    <div>
        <v-container fluid>
            <v-card>
                <v-app-bar dark color="#81c342">
                    <v-toolbar-title>
                        <span><v-icon class="mr-3" dark>mdi-cogs</v-icon></span>
                        <span class="title">Learning Resources</span>
                    </v-toolbar-title>
                </v-app-bar>
                <v-container height="700px" fluid>
                    <v-skeleton-loader :loading="loading" transition="scale-transition"
                                       type="table-tbody">
                    <v-row>
                        <v-col cols="12" md="12" lg="12" class="text-center">
                            <v-data-table :headers="headers" :items="itemsWithIndex" :hide-default-footer="true">
                                <template v-slot:item.download="{ item }">
                                    <span v-if="item.fileAvailable">
                                        <v-icon color="green" @click.native="downloadFile(item.id,item.resourceName,item.type)" style="cursor: pointer">mdi-file-download</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon>mdi-file-download</v-icon>
                                    </span>

                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    </v-skeleton-loader>
                </v-container>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {dataServices, downloadFileService} from "../services";
    import fileSaver from 'file-saver'
    export default {
        name: "LearningResources",
        data() {
            return {
                tableData: [],
                loading: false,
                headers: [
                    {
                        text: 'No.', align: 'center', sortable: false, value: 'index', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Materials', align: 'center', sortable: false, value: 'resourceName', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Download', align: 'center', sortable: false, value: 'download', selectedCheckbox: true,
                        toggle: false
                    },
                ]
            }
        },
        methods: {
            getPageData: function () {
                this.loading = true
                dataServices.getLearningResources().then(response => {
                    if (response.dataResponse.learningResourcesData != null){
                        this.tableData = response.dataResponse.learningResourcesData
                    }
                    this.loading = false
                })
            },
            downloadFile : function (item,name,extension) {
                downloadFileService.downloadResource({id: item}).then(response => {
                    if (response) {
                        console.log(response,name+'.'+extension)
                        fileSaver.saveAs(response,name+'.'+extension)
                    }
                })
            }
        },
        computed: {
            itemsWithIndex: function () {
                return this.tableData.map(
                    (item, index) => ({
                        ...item,
                        index: index + 1
                    }))
            }
        },
        mounted() {
            this.getPageData();
        }
    }
</script>

<style scoped>

</style>
